export default __webpack_public_path__ + "static/media/30415holiday.jpeg.6c7e7892.jpeg";